import { Dispatch } from "redux";
import { setLoading } from "./global";
import { showMessage } from "utilities/helper";
import UserComplaintService from "service/UserComplaint";

export const getAllUserComplaint =
  (
    page: number = 1,
    search: string = "",
    limit: number = 10,
  ) =>
  async (dispatch: Dispatch) => {
    dispatch(setLoading(true));
    dispatch({
      type: "SET_USER_COMPLAINT_CURRENT_PAGE",
      currentPage: page,
    });
    dispatch({
      type: "SET_SEARCH_USER_COMPLAINT",
      searchValue: search,
    });

    try {
      const data = await UserComplaintService.getAllUserComplaint(
        page,
        search,
        limit,
      );

      dispatch(setLoading(false));
      dispatch({ type: "SET_USER_COMPLAINT", value: data.complaints });
      dispatch({
        type: "SET_USER_COMPLAINT_PAGE",
        totalPage: !!data.complaints.length ? data.last_page : 1,
        limitPage: limit,
        lengthPage: !!data.complaints.length ? data.total_data : 1,
      });
      dispatch({
        type: "SET_USER_COMPLAINT_FILTER_PAGE",
      });
    } catch (err: any) {
      dispatch(setLoading(false));
      if (err.request.status !== 401) {
        console.log("error :", err);
        showMessage(
          !err.response
            ? err.message
            : !!err.response?.data?.error
            ? err.response?.data?.error
            : err.response?.data?.message,
          "error"
        );
      }
    }
  };

